/* eslint-disable */
/**
 * PostCheckoutConfirmation Component
 *
 * Displays the "Purchase Successful" confirmation on the Left_Panel after
 * the purchase is verified. "Jump to Agreement" button is in the footer.
 *
 * Requirements: 4.1, 4.2
 */
import React from 'react';
import { makeStyles, Typography, Grid } from '@rentacenter/racstrap';
import { ReactComponent as SuccessCheckmark } from '../../assets/images/validation-success.svg';

export interface PostCheckoutConfirmationProps {
  approvalLimitAmount: string;
}

const FONT_CHOICE = 'OpenSans-semibold';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    padding: '0.5rem 0.75rem',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '0.25rem',
  },
  successIcon: {
    width: '28px',
    height: '28px',
    color: '#2E7D32',
  },
  title: {
    fontSize: '0.875rem',
    fontFamily: FONT_CHOICE,
    fontWeight: 700,
    textAlign: 'center' as const,
    color: '#2E7D32',
    marginBottom: '0.375rem',
  },
  transactionCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.75rem',
    backgroundColor: '#E8F1FE',
    borderRadius: '6px',
    padding: '0.375rem 0.75rem',
    width: '100%',
  },
  transactionLabel: {
    fontSize: '0.65rem',
    fontFamily: FONT_CHOICE,
    color: '#333333',
  },
  transactionAmount: {
    fontSize: '0.875rem',
    fontFamily: FONT_CHOICE,
    fontWeight: 700,
    color: '#111111',
  },
}));

export const PostCheckoutConfirmation: React.FC<PostCheckoutConfirmationProps> = ({
  approvalLimitAmount,
}) => {
  const classes = useStyles();

  const formattedAmount = approvalLimitAmount
    ? `$${parseFloat(approvalLimitAmount).toFixed(2)}`
    : '$0.00';

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.root}
    >
      <Grid item className={classes.iconContainer}>
        <SuccessCheckmark className={classes.successIcon} />
      </Grid>

      <Grid item>
        <Typography className={classes.title}>
          Purchase Successful
        </Typography>
      </Grid>

      <Grid item className={classes.transactionCard}>
        <Typography className={classes.transactionLabel}>
          Transaction Amount
        </Typography>
        <Typography className={classes.transactionAmount}>
          {formattedAmount}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PostCheckoutConfirmation;
